import React from 'react';
import { useFormik } from 'formik';
import { Box, Button } from '@mui/material';
import { updateGoogleSheet } from 'services/api/project';

const switchStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    flexWrap: 'wrap',
};

export const BaseForm = ({
    initial,
    setOpen,
    googleSheetURL,
    matches,
    refetch,
    lock,
    setLock,
    validationSchema,
    allowedChanges,
    toSheet,
    fromSheet,
    renderFields,
}) => {
    // const classes = useStyles();

    const formik = useFormik({
        initialValues: fromSheet(initial),
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            setLock(!lock);
            const sheetData = toSheet(values);
            const updates = Object.keys(sheetData).reduce((acc, key) => {
                if (allowedChanges.includes(key) && initial[key] !== sheetData[key] && matches[key]) {
                    acc.push({ range: matches[key], values: [[sheetData[key]]] });
                }
                return acc;
            }, []);
            if (updates.length === 0) {
                setLock(lock);
                setOpen(false);
                return;
            }

            try {
                await updateGoogleSheet(googleSheetURL, updates);
                refetch().then(() => {
                    setLock(lock);
                });
                setOpen(false);
            } catch (err) {
                console.log(err);
            }
        },
    });

    return (
        <form onSubmit={formik.handleSubmit}>
            <Box>
                {renderFields(formik, { switch: switchStyles })}

                <Box sx={{ mt: 4 }}>
                    <Button
                        variant="contained"
                        type="submit"
                        disabled={lock}
                        fullWidth
                        sx={{
                            backgroundColor: '#3ECF8E',
                            color: 'white',
                            fontWeight: 600,
                            height: '48px',
                            borderRadius: '6px',
                            textTransform: 'none',
                            fontSize: '0.95rem',
                            boxShadow: 'none',
                            '&:hover': {
                                backgroundColor: '#13B888',
                                boxShadow: '0 2px 8px rgba(62, 207, 142, 0.2)',
                            },
                            '&.Mui-disabled': {
                                backgroundColor: '#E5E7EB',
                                color: '#94A3B8',
                            },
                        }}
                    >
                        Hesapla
                    </Button>
                </Box>
            </Box>
        </form>
    );
};
